import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { Subtitle2 } from '@src/elements/typography/typography'

import './breadcrumbs.sass'
import { noop } from '@src/util/noop'

@Component
export class Breadcrumbs extends Vue {

  @Prop({ required: true })
  crumbs: string[]

  @Prop({ required: false, default: noop })
  clickAction: () => void

  render (h: CreateElement) {

    return (
      <div class='element-breadcrumbs'>
        {
          this.crumbs.map((crumb, index) => {
            return <div class='breadcrumb' onClick={this.clickAction}>
              <Subtitle2>{crumb}</Subtitle2>
            </div>
          })
        }
      </div>
    )
  }

}
